<div class="not-found">
  <div class="not-found__content">
    <img
      class="not-found__image"
      src="assets/images/not-found/404-text.svg"
      alt="404"
    />

    <div class="not-found__text">
      <h1 class="not-found__title">Page Not Found</h1>

      <p class="not-found__subtitle">
        You may have used an invalid link
        <br />
        or the page may have been deleted.
      </p>
    </div>

    <a class="not-found__button" routerLink="/">I'm Feeling Lucky</a>
  </div>

  <img
    class="not-found__plug"
    src="assets/images/not-found/plug-illustration.svg"
    alt=""
  />
</div>
